import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

// Default redirect paths for each role when access is denied
const ROLE_HOME = {
  admin: '/admin-analysis',
  cliente: '/client-analysis',
};

// Route wrapper that enforces authentication and optional role-based access control.
// Redirects unauthenticated users to '/' and unauthorized roles to their home page.
const ProtectedRoute = ({ component: Component, roles, ...rest }) => {
  const { user, isAuthenticated, isLoading } = useAuth();

  // Returns the render result for the protected route based on auth and role state
  const renderRoute = (props) => {
    // Show loading indicator while the initial auth check is in progress
    if (isLoading) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          Cargando...
        </div>
      );
    }

    // Redirect unauthenticated users to the login page
    if (!isAuthenticated) {
      return <Redirect to="/" />;
    }

    // Redirect to role home if user's role is not in the allowed roles list
    if (roles && !roles.includes(user.rol)) {
      const redirectTo = ROLE_HOME[user.rol] || '/';
      return <Redirect to={redirectTo} />;
    }

    return <Component {...props} />;
  };

  return <Route {...rest} render={renderRoute} />;
};

export default ProtectedRoute;
